import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CartModule } from '../cart/cart.module';
import { CashBoxModule } from '../cashbox/cash-box.module';
import { CoreModule } from '../core/core.module';
import { InfiniteScrollComponent } from './infinite-scroll.component';
import { ProductCollectionSelectComponent } from './product-collection-select.component';
import { ProductDetailsVariantListComponent } from './product-details-variant-list.component';
import { ProductDetailsVariantComponent } from './product-details-variant.component';
import { ProductDetailsComponent } from './product-details.component';
import { ProductFilterComponent } from './product-filter.component';
import { ProductSimpleComponent } from './product-simple.component';
import { ProductVariantSelectorComponent } from './product-variant-selector.component';
import { ProductComponent } from './product.component';
import { ProductsRoutingModule } from './products-routing.module';
import { ProductsPage } from './products.page';

@NgModule({
    imports: [
        CommonModule,
        ProductsRoutingModule,
        CoreModule,
        ReactiveFormsModule,
        CartModule,
        CashBoxModule,
        NgbToastModule,
        LazyLoadImageModule
    ],
    declarations: [
        InfiniteScrollComponent,
        ProductsPage,
        ProductComponent,
        ProductSimpleComponent,
        ProductDetailsComponent,
        ProductDetailsVariantComponent,
        ProductDetailsVariantListComponent,
        ProductFilterComponent,
        ProductCollectionSelectComponent,
        ProductVariantSelectorComponent
    ],
    exports: [
        InfiniteScrollComponent
    ],
    providers: []
})
export class ProductsModule {
}
